import "./SelectComp.css";
import { defineComponent as l, getCurrentInstance as c, openBlock as m, createBlock as u, resolveDynamicComponent as d, mergeProps as f, createSlots as y, withCtx as r, renderSlot as p } from "vue";
import { u as _ } from "./uniqueId.f48d78c2.js";
import { a as i, b as a, v } from "./main.88c600c1.js";
import { _ as S } from "./_plugin-vue_export-helper.dad06003.js";
const g = ["underlined", "outlined", "filled", "solo", "plain"], h = l({
  components: {
    VSelect: i,
    VAutocomplete: a
  },
  props: {
    id: {
      type: String,
      required: !1,
      default: () => _("selectComp")
    },
    autocomplete: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "primary"
    },
    variant: {
      type: String,
      default: "solo",
      validator: (e) => g.includes(e)
    },
    density: {
      type: String,
      default: "compact"
    },
    itemTitle: {
      type: String,
      default: "text"
    },
    menuProps: {
      type: [String, Array, Object],
      default: () => ({
        maxHeight: 300
      })
    },
    menuIcon: {
      type: String,
      default: "$expand"
    },
    validateOn: {
      type: String,
      default: "blur"
    }
  },
  computed: {
    componentType() {
      return this.autocomplete ? a : i;
    }
  },
  methods: {
    hasSlot(e) {
      return !!this.$slots[e];
    },
    getInnerRef() {
      return this.$refs[this.id];
    }
  },
  setup() {
    const e = c();
    e && !e.appContext.mixins.some((s) => {
      var t;
      return (t = s.computed) == null ? void 0 : t.$vuetify;
    }) && e.appContext.app.use(v);
  }
});
function $(e, s, t, C, I, b) {
  return m(), u(d(e.componentType), f({ class: "v-theme--customTheme" }, e.$props, { ref: e.id }), y({ _: 2 }, [
    e.hasSlot("item") ? {
      name: "item",
      fn: r(({ item: o, index: n }) => [
        p(e.$slots, "item", {
          item: o,
          index: n
        }, void 0, !0)
      ]),
      key: "0"
    } : void 0,
    e.hasSlot("selection") ? {
      name: "selection",
      fn: r(({ item: o, index: n }) => [
        p(e.$slots, "selection", {
          item: o,
          index: n
        }, void 0, !0)
      ]),
      key: "1"
    } : void 0
  ]), 1040);
}
const q = /* @__PURE__ */ S(h, [["render", $], ["__scopeId", "data-v-75cbc71e"]]);
export {
  q as SelectComp
};
//# sourceMappingURL=SelectComp.js.map
